export const ePlayerUiWinLineTypes = {
  EWLT_X_LINES: 'x_lines',
  EWLT_MEGAWAYS: 'megaways',
  EWLT_MATCH_3: 'match_3',
}
